import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class PermissionValidator extends BaseValidator {
  validatorRules = {
    Id: {
      required: true,
      type    : BaseValidator.Type.Number
    },
    Name: {
      required: true,
      type    : BaseValidator.Type.String,
      minLen  : 2
    },
    Description: {
      required  : true,
      type      : BaseValidator.Type.String,
      betweenLen: [2, 255]
    },
    Status: {
      required: true,
      type    : BaseValidator.Type.Boolean
    },
    Admin: {
      required: true,
      type    : BaseValidator.Type.Boolean
    },
    Action: {
      required: true,
      type    : BaseValidator.Type.Array
    },
    Requires: {
      required: true,
      type    : BaseValidator.Type.Object
    }
  }

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
